import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React, { useState, useEffect } from 'react';
import toastr from 'toastr';
import ReactDOM from 'react-dom';
import '@style/style.scss';
import * as Sentry from '@sentry/browser';
import { apiFetch, getApiErrorMessage } from '../../utils/apiFetch.js';

import { prepareApp } from '../../mocks/prepare.js';

Sentry.init({dsn: SENTRY_DSN, environment: SENTRY_ENV});

const App = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    document.title = 'Login - Kelogs';
    if (window.userEmail) {
      window.location.href = '/projects';
    }
  }, []);

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const login = async (e) => {
    e.preventDefault();
    if (!email || email.indexOf('@') === -1) {
      toastr.error('Please enter a valid email.');
      return;
    }
    if (!password) {
      toastr.error('Please enter a valid password.');
      return;
    }

    try {
      const data = await apiFetch('/api/v1/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password,
        })
      });

      if (!data) {
        return;
      }
      window.location.href = '/projects';
    } catch (err) {
      toastr.error(getApiErrorMessage(err));
    }
  };

  return (
    <div className='d-flex flex-column flex-row-fluid wrapper'>
      <div className='content d-flex flex-column flex-column-fluid'>
        <div className='subheader py-6 py-lg-8 subheader-transparent'>
          <div className='container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap'>
            <div className='d-flex align-items-center flex-wrap mr-1'>
              <div className='d-flex align-items-baseline flex-wrap mr-5'>
                <h5 className='text-dark font-weight-bold my-1 mr-5'>
                  Login
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div className='container'>
          <div className='card card-custom'>
            <div className='card-header'>
              <div className='card-title'>
                <h3 className='card-label'>
                  Login
                </h3>
              </div>
            </div>
            <form className='form' noValidate onSubmit={login}>
              <div className='card-body'>
                <div className='form-group'>
                  <label>Email</label>
                  <input className='form-control' type='email' placeholder='user@example.com' value={email} onChange={handleChangeEmail} />
                </div>
                <div className='form-group form-group-last'>
                  <label>Password</label>
                  <input className='form-control' type='password' placeholder='Password' value={password} onChange={handleChangePassword} />
                  <a className='font-size-sm font-weight-bold my-5' href='/forgot'>
                    Forgot password?
                  </a>
                </div>
              </div>
              <div className='card-footer'>
                <button type='submit' className='btn btn-primary'>
                  Login
                </button>
                <span className='ml-10'>
                  or <a href='/signup'>Create an account</a>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className='footer bg-white py-4 d-flex flex-lg-column'>
        <div className='container d-flex flex-column flex-md-row align-items-center justify-content-between'>
          <div className='text-dark order-2 order-md-1'> {(new Date()).getFullYear()}&nbsp;&copy;&nbsp;Kelogs </div>

          <div className='nav nav-dark'>
            <a className='nav-link pl-0 pr-2' target='_blank' href='https://www.kelo.gs/wp-content/uploads/2019/08/TERMS-AND-CONDITIONS-KELOGS.pdf' rel="noreferrer">Terms of Service</a>
            <a className='nav-link pr-2' target='_blank' href='https://www.kelo.gs/wp-content/uploads/2019/08/LegalNoticesKelogs.pdf' rel="noreferrer">Legal Notices</a>
            <a className='nav-link pr-2' target='_blank' href='https://www.kelo.gs/wp-content/uploads/2019/08/PrivacyTerms.pdf' rel="noreferrer">Privacy Terms</a>
            <a className='nav-link pr-0' target='_blank' href='mailto:sales@kelo.gs' rel="noreferrer">Affiliation</a>
          </div>
        </div>
      </div>
    </div>
  );
};

const rootElement = document.getElementById('root');

prepareApp().then(() => {
  ReactDOM.render(<App />, rootElement);
});
;
